<div class="runs-root" [class.runs-root-embedded]="embedded()">
<div class="panel">
  <div class="fq-card-header fuseqCardHeader flex justify-between items-center">
    <span>Monitor run — Workflow</span>
    <div class="flex items-center gap-3">
      @if (lastRefresh()) {
        <span class="text-xs opacity-70 runs-last-refresh">Aggiornato: {{ formatTime(lastRefresh()) }}</span>
      }
      <div class="runs-auto-refresh flex items-center gap-2 text-xs">
        <p-toggleswitch inputId="runs-auto-refresh" [ngModel]="autoRefresh()" (ngModelChange)="autoRefresh.set($event)" />
        <label for="runs-auto-refresh" class="cursor-pointer select-none">Aggiornamento auto</label>
      </div>
      <button type="button" class="fq-btn fq-btn-primary fq-btn-sm" (click)="load()" title="Aggiorna">
        <i class="fa-solid fa-rotate"></i>
      </button>
    </div>
  </div>

  <div class="panel-body">
    @if (error()) {
      <div class="runs-empty">
        <i class="fa-solid fa-triangle-exclamation"></i>
        <span>{{ error() }}</span>
        <button type="button" class="fq-btn fq-btn-danger fq-btn-sm" (click)="load()">Riprova</button>
      </div>
    } @else {
      <!-- Counts & status filters -->
      <div class="flex flex-wrap items-center justify-center gap-2 mb-3">
        <button type="button" class="fq-stat-pill fq-stat-secondary" [class.is-active]="statusFilter() === 'all'" (click)="setFilter('all')">
          {{ filterLabel('all') }} <span class="fq-stat-pill-count">{{ counts().all }}</span>
        </button>
        <button type="button" class="fq-stat-pill fq-stat-warning" [class.is-active]="statusFilter() === 'active'" (click)="setFilter('active')">
          {{ filterLabel('active') }} <span class="fq-stat-pill-count">{{ counts().active }}</span>
        </button>
        <button type="button" class="fq-stat-pill fq-stat-info" [class.is-active]="statusFilter() === 'scheduled'" (click)="setFilter('scheduled')">
          {{ filterLabel('scheduled') }} <span class="fq-stat-pill-count">{{ counts().scheduled }}</span>
        </button>
        <button type="button" class="fq-stat-pill fq-stat-info" [class.is-active]="statusFilter() === 'waiting'" (click)="setFilter('waiting')">
          {{ filterLabel('waiting') }} <span class="fq-stat-pill-count">{{ counts().waiting }}</span>
        </button>
        <button type="button" class="fq-stat-pill fq-stat-success" [class.is-active]="statusFilter() === 'completed'" (click)="setFilter('completed')">
          {{ filterLabel('completed') }} <span class="fq-stat-pill-count">{{ counts().completed }}</span>
        </button>
        <button type="button" class="fq-stat-pill fq-stat-danger" [class.is-active]="statusFilter() === 'failed'" (click)="setFilter('failed')">
          {{ filterLabel('failed') }} <span class="fq-stat-pill-count">{{ counts().failed }}</span>
        </button>
      </div>

      <fq-table
        [tableId]="tableId"
        [value]="filteredRuns()"
        [loading]="loading()"
        [columns]="tableColumns"
        [scrollable]="true"
        [scrollHeight]="'calc(80vh - 200px)'"
        [virtualScroll]="true"
        [virtualScrollItemSize]="34"
        [showSearch]="true"
        [globalFilterFields]="['run_name', 'status', 'fraz']"
        [sortField]="'when'"
        [sortOrder]="-1"
        [exportFileName]="'MediationRuns'"
        [emptyMessage]="'Nessuna run corrisponde ai filtri'">
        <ng-template #emptymessage>
          <div class="runs-empty">
            <i class="fa-solid fa-inbox"></i>
            <span class="runs-empty-title">Nessuna run trovata</span>
            <span class="runs-empty-hint">Prova a rimuovere i filtri o a verificare che il workflow sia stato avviato.</span>
            <button type="button" class="fq-btn fq-btn-sm fq-btn-secondary" (click)="resetFilters()">Azzera filtri</button>
          </div>
        </ng-template>
        <ng-template #captionActions>
          @if (frazFilter()) {
            <span class="fraction-filter fraction-filter-locked" [title]="'Storico filtrato sulla sede ' + frazFilter()">
              <i class="fa-solid fa-lock fraction-filter-icon"></i>
              {{ frazFilter() }}
            </span>
          } @else {
            <span class="fraction-filter">
              <i class="fa-solid fa-magnifying-glass fraction-filter-icon"></i>
              <p-select
                [options]="fractionOptions()"
                [filter]="true"
                [showClear]="true"
                [virtualScroll]="true"
                [virtualScrollItemSize]="35"
                [ngModel]="fractionSearch()"
                (ngModelChange)="setFractionSearch($event)"
                optionLabel="label"
                optionValue="value"
                placeholder="Cerca frazionario"
                styleClass="fraction-filter-select"
                appendTo="body">
              </p-select>
            </span>
          }
        </ng-template>
        <ng-template #body let-row let-columnsOptions="columnsOptions">
          <tr class="whitespace-nowrap" [class.run-row-active]="isRunActive(row.status)">
            @for (col of columnsOptions; track col.field) {
              @switch (col.field) {
                @case ('run_name') {
                  <td class="text-left">
                    <span class="run-name" title="{{ row.run_name }}">{{ row.run_name }}</span>
                  </td>
                }
                @case ('state') {
                  <td class="text-center">
                    <div class="run-state-cell">
                      <span class="run-status-pill" [ngClass]="statusKey(row.status)">
                        <i [class]="statusIcon(row.status)" aria-hidden="true"></i>
                        {{ statusLabel(row.status) }}
                      </span>
                      @if (runProgress(row); as progress) {
                        <span class="run-progress" title="{{ progress.done }} step completati su {{ progress.total }}">
                          <span class="run-progress-bar">
                            <span class="run-progress-fill" [style.width.%]="progress.total ? (progress.done / progress.total) * 100 : 0"></span>
                          </span>
                          <span class="run-progress-text">{{ progress.done }}/{{ progress.total }} step</span>
                        </span>
                      }
                      @if (runFailedFrazCount(row) > 0) {
                        <span class="run-fail-note" title="Frazionari con almeno uno step fallito">
                          <i class="fa-solid fa-triangle-exclamation" aria-hidden="true"></i>
                          {{ runFailedFrazCount(row) }} frazionari in errore
                        </span>
                      }
                    </div>
                  </td>
                }
                @case ('when') {
                  <td class="text-center run-when">{{ runWhen(row) }}</td>
                }
                @case ('fraz') {
                  <td class="text-center">
                    <button
                      type="button"
                      class="fraz-drill-btn"
                      [disabled]="!row.fraz?.length && !row.results?.length"
                      title="Dettagli frazionario"
                      (click)="openFrazDrill(row, $event)">
                      <i class="fa-solid fa-list-check"></i>
                      <span>{{ row.fraz?.length ?? 0 }}</span>
                      <i class="fa-solid fa-chevron-down text-[10px]"></i>
                    </button>
                  </td>
                }
                @case ('ops') {
                  <td class="text-center">
                    <div class="flex items-center justify-end gap-1">
                      <button type="button" class="fq-btn fq-btn-link" title="Dettagli" (click)="openDetail(row)">
                        <i class="fa-solid fa-eye"></i>
                      </button>
                      @if (isRunActive(row.status) && !row.cancelRequested) {
                        <button type="button" class="fq-btn fq-btn-link text-amber-600" title="Annulla run" (click)="cancelRun(row, $event)">
                          <i class="fa-solid fa-ban"></i>
                        </button>
                      }
                      @if (row.status === 'failed') {
                        <button type="button" class="fq-btn fq-btn-link text-sky-600" title="Riprova solo i frazionari falliti" (click)="retryRun(row, $event)">
                          <i class="fa-solid fa-rotate-right"></i>
                        </button>
                      }
                      @if (isRunTerminal(row.status)) {
                        <button type="button" class="fq-btn fq-btn-link text-red-600" title="Elimina run" (click)="deleteRun(row, $event)">
                          <i class="fa-solid fa-trash"></i>
                        </button>
                      }
                    </div>
                  </td>
                }
                @default {
                  <td class="text-center">{{ row[col.field] }}</td>
                }
              }
            }
          </tr>
        </ng-template>
      </fq-table>

      @if (total() > pageSize) {
        <div class="flex items-center justify-between gap-3 mt-3 text-xs runs-pagination">
          <span class="opacity-70">
            Pagina {{ page() + 1 }} di {{ pageCount() }} · {{ total() }} run
          </span>
          <div class="flex items-center gap-2">
            <button type="button" class="fq-btn fq-btn-sm fq-btn-secondary" [disabled]="page() === 0" (click)="previousPage()">
              <i class="fa-solid fa-chevron-left"></i> Indietro
            </button>
            <span class="flex items-center gap-1.5">
              <input
                type="number"
                class="fq-form-control runs-page-jump"
                min="1"
                [max]="pageCount()"
                [value]="page() + 1"
                (change)="goToPage($any($event.target).value - 1)" />
              <span class="opacity-70">di {{ pageCount() }}</span>
            </span>
            <button type="button" class="fq-btn fq-btn-sm fq-btn-secondary" [disabled]="page() + 1 >= pageCount()" (click)="nextPage()">
              Avanti <i class="fa-solid fa-chevron-right"></i>
            </button>
          </div>
        </div>
      }
    }
  </div>
</div>

<!-- Contenuto condiviso del drill-down frazionari (drawer standalone / pannello embedded) -->
<ng-template #frazDrillContent>
@if (detailRun(); as run) {
    <div class="run-results runs-drawer-body">
      <section class="panel run-summary">
        <div class="panel-body flex flex-wrap items-center gap-3">
          <strong class="drill-run-name">{{ run.run_name }}</strong>
          <span class="run-status-pill" [ngClass]="statusKey(run.status)">
            <i [class]="statusIcon(run.status)" aria-hidden="true"></i>
            {{ statusLabel(run.status) }}
          </span>
          <span class="run-meta"><i class="fa-regular fa-clock"></i> {{ executionModeLabel(run) }}</span>
          @if (run.scheduled_at) {
            <span class="run-meta"><i class="fa-regular fa-calendar"></i> {{ formatDateTime(run.scheduled_at) }}</span>
          }
          <span class="run-meta"><i class="fa-solid fa-calendar-plus"></i> creata {{ formatDateTime(run.createdAt) }}</span>
          <span class="run-meta"><i class="fa-solid fa-location-dot"></i> {{ drillRows().length }} frazionari</span>
          <span class="run-meta"><i class="fa-solid fa-bolt"></i> {{ run.actions?.length ?? 0 }} azioni</span>
          @if (failedFractionsCount()) {
            <span class="run-meta run-meta-danger"><i class="fa-solid fa-triangle-exclamation"></i> {{ failedFractionsCount() }} in errore</span>
          }
          <span class="ml-auto">
            @if (isRunActive(run.status)) {
              <button type="button" class="fq-btn fq-btn-sm fq-btn-secondary" (click)="refreshDetail()">
                <i class="fa-solid fa-rotate"></i> Aggiorna
              </button>
            }
          </span>
        </div>
        @if (run.error) {
          <div class="run-error-banner">
            <i class="fa-solid fa-circle-exclamation"></i>
            <span>{{ run.error }}</span>
          </div>
        }
      </section>

      @if (drillRows().length) {
        <section class="panel">
          <div class="fq-card-header fuseqCardHeader flex flex-wrap items-center justify-between gap-2">
            <span>Frazionari <span class="opacity-70">({{ drillRows().length }})</span></span>
            <span class="text-xs font-normal opacity-70">Seleziona un frazionario per vedere gli step</span>
          </div>
          <div class="panel-body drill-body">
            <div class="drill-list">
              @for (row of drillRows(); track row.fraz) {
                <div class="drill-item" [class.is-open]="isFrazSelected(row.fraz)">
                  <button type="button" class="drill-row" [attr.aria-expanded]="isFrazSelected(row.fraz)" (click)="selectFraz(row.fraz)">
                    <span class="drill-fraz">{{ row.fraz }}</span>
                    <span class="run-status-pill" [ngClass]="statusKey(row.status)">{{ statusLabel(row.status) }}</span>
                    <span class="drill-steps" title="Step: ok / ko / totali">
                      <i class="fa-solid fa-circle-check ok" aria-hidden="true"></i>
                      <b class="ok">{{ row.successCount }}</b>
                      <i class="fa-solid fa-circle-xmark ko" [class.is-zero]="!row.failedCount" aria-hidden="true"></i>
                      <b class="ko" [class.is-zero]="!row.failedCount">{{ row.failedCount }}</b>
                      <span class="sep">/</span>{{ row.steps.length }}
                      <span class="drill-steps-label">step</span>
                    </span>
                    <span class="drill-tags">
                      @for (tag of row.addedTags; track tag) { <span class="chip add-tag">+ {{ tagName(tag) }}</span> }
                      @for (tag of row.removedTags; track tag) { <span class="chip remove-tag">- {{ tagName(tag) }}</span> }
                    </span>
                    <span class="drill-duration">{{ formatDuration(row.durationMs) }}</span>
                    <i class="fa-solid" [ngClass]="isFrazSelected(row.fraz) ? 'fa-chevron-up' : 'fa-chevron-down'" aria-hidden="true"></i>
                  </button>

                  @if (row.error) {
                    <div class="drill-row-error" [title]="(row.failedStepLabel ? row.failedStepLabel + ': ' : '') + row.error">
                      <i class="fa-solid fa-triangle-exclamation" aria-hidden="true"></i>
                      @if (row.failedStepLabel) { <strong>{{ row.failedStepLabel }}</strong> }
                      <span class="drill-row-error-text">{{ row.error }}</span>
                    </div>
                  }

                  @if (isFrazSelected(row.fraz)) {
                    <div class="drill-detail">
                      @if (row.steps.length) {
                        @for (step of row.steps; track step.stepId + '-' + $index) {
                          <div class="drill-step" [class.is-failed]="step.status === 'failed'">
                            <span class="drill-step-label">
                              <span class="step-dot" [ngClass]="statusKey(step.status)"></span>
                              {{ step.stepLabel }}
                            </span>
                            <span class="run-status-pill" [ngClass]="statusKey(step.status)">{{ statusLabel(step.status) }}</span>
                            <span class="drill-step-tags">
                              @for (tag of step.addedTags ?? []; track tag) { <span class="chip add-tag">+ {{ tagName(tag) }}</span> }
                              @for (tag of step.removedTags ?? []; track tag) { <span class="chip remove-tag">- {{ tagName(tag) }}</span> }
                            </span>
                            @if (step.message) {
                              <span class="drill-step-msg" [title]="step.message">{{ step.message }}</span>
                            }
                            <span class="drill-step-duration">{{ formatDuration(step.durationMs) }}</span>
                            @if (step.details) {
                              <details class="run-step-details">
                                <summary>Dettagli</summary>
                                <pre>{{ step.details | json }}</pre>
                              </details>
                            }
                          </div>
                        }
                      } @else {
                        <div class="runs-empty">
                          <i class="fa-solid fa-list-check" aria-hidden="true"></i>
                          @if (isRunActive(run.status)) {
                            <span>Esecuzione in corso… aggiorna per vedere i primi step.</span>
                          } @else {
                            <span>Nessuno step registrato per questo frazionario.</span>
                          }
                        </div>
                      }
                    </div>
                  }
                </div>
              }
            </div>
          </div>
        </section>
      } @else {
        <div class="runs-empty">
          <i class="fa-solid fa-inbox" aria-hidden="true"></i>
          @if (isRunActive(run.status)) {
            <span>Esecuzione in corso… aggiorna per vedere i risultati.</span>
          } @else {
            <span>Nessun risultato disponibile.</span>
          }
        </div>
      }
    </div>
  }
</ng-template>

<!--
  DRILL-DOWN FRAZIONARI — pannello laterale non modale.
  Nessuna mask e nessun blocco dello scroll: la tabella sotto resta cliccabile.
  In embedded si ancora al monitor (root relativo), in standalone al viewport.
-->
<div class="runs-inline-drill" [class.is-open]="drillOpen()" [attr.aria-hidden]="!drillOpen()" [attr.inert]="drillOpen() ? null : ''">
  <div class="fq-card-header fuseqCardHeader flex justify-between items-center runs-inline-drill-header">
    <span>Dettaglio frazionari</span>
    <button type="button" class="runs-inline-drill-close" (click)="closeFrazDrill()" title="Chiudi" aria-label="Chiudi dettaglio frazionari">
      <i class="fa-solid fa-xmark"></i>
    </button>
  </div>
  <div class="runs-inline-drill-body">
    <ng-template [ngTemplateOutlet]="frazDrillContent" />
  </div>
</div>

<!-- RUN DETAIL -->
<p-dialog
  [closable]="true"  [visible]="detailOpen()"
  (visibleChange)="$event ? detailOpen.set(true) : closeDetail()"
  [modal]="true"
  [maximizable]="true"
  [style]="{ width: '80vw' }"
  [breakpoints]="{ '960px': '95vw' }"
  [header]="detailRun()?.run_name || 'Dettaglio run'">
  @if (detailRun(); as run) {
    <div class="run-results">
      <section class="panel run-summary">
        <div class="panel-body flex flex-wrap items-center gap-3">
          <span class="run-status-pill" [ngClass]="statusKey(run.status)">
            <i [class]="statusIcon(run.status)" aria-hidden="true"></i>
            {{ statusLabel(run.status) }}
          </span>
          <span class="run-meta"><i class="fa-regular fa-clock"></i> {{ executionModeLabel(run) }}</span>
          @if (run.scheduled_at) {
            <span class="run-meta"><i class="fa-regular fa-calendar"></i> {{ formatDateTime(run.scheduled_at) }}</span>
          }
          <span class="run-meta"><i class="fa-solid fa-calendar-plus"></i> creata {{ formatDateTime(run.createdAt) }}</span>
          <span class="run-meta"><i class="fa-solid fa-location-dot"></i> {{ run.fraz?.length ?? 0 }} frazionari</span>
          <span class="run-meta"><i class="fa-solid fa-bolt"></i> {{ run.actions?.length ?? 0 }} azioni</span>
          @if (failedFractionsCount()) {
            <span class="run-meta run-meta-danger"><i class="fa-solid fa-triangle-exclamation"></i> {{ failedFractionsCount() }} in errore</span>
          }
          <span class="run-view-toggle">
            <button type="button" [class.active]="detailView() === 'details'" (click)="setDetailView('details')" title="Vista dettagli">
              <i class="fa-solid fa-list"></i> Dettagli
            </button>
            <button type="button" [class.active]="detailView() === 'graph'" (click)="setDetailView('graph')" title="Vista grafo">
              <i class="fa-solid fa-diagram-project"></i> Grafo
            </button>
          </span>
          <span class="ml-auto flex items-center gap-2">
            @if (run.fraz?.length) {
              <button type="button" class="fq-btn fq-btn-sm fq-btn-primary" (click)="openFrazDrill(run)">
                <i class="fa-solid fa-list-check"></i> Dettaglio frazionari
              </button>
            }
            @if (isRunActive(run.status)) {
              <button type="button" class="fq-btn fq-btn-sm fq-btn-secondary" (click)="refreshDetail()">
                <i class="fa-solid fa-rotate"></i> Aggiorna
              </button>
            }
          </span>
        </div>
        @if (run.error) {
          <div class="run-error-banner">
            <i class="fa-solid fa-circle-exclamation"></i>
            <span>{{ run.error }}</span>
          </div>
        }
      </section>

      @if (detailView() === 'graph') {
        <section class="panel">
          <div class="fq-card-header fuseqCardHeader flex justify-between items-center">
            <span>Grafo di esecuzione</span>
            <span class="flex items-center gap-2">
              <span class="text-xs font-semibold uppercase opacity-70">Frazionario</span>
              <p-select
                [options]="graphFractionOptions()"
                [ngModel]="graphFractionValue"
                (ngModelChange)="selectGraphFraction($event)"
                [filter]="true"
                [showClear]="false"
                optionLabel="label"
                optionValue="value"
                styleClass="run-graph-fraction"
                appendTo="body">
              </p-select>
            </span>
          </div>
          <div class="panel-body">
            <app-workflow-graph
              [nodes]="runGraphNodes()"
              [editable]="false"
              [selectedId]="graphSelectedNodeId()"
              (selectNode)="onGraphNodeSelect($event)">
            </app-workflow-graph>

            @if (selectedGraphNode(); as node) {
              <div class="run-graph-inspector">
                <div class="flex flex-wrap items-center gap-2">
                  <i [class]="node.icon" class="run-action-icon"></i>
                  <strong>{{ node.label }}</strong>
                  @if (selectedGraphResult(); as step) {
                    <span class="run-status-pill" [ngClass]="statusKey(step.status)">{{ statusLabel(step.status) }}</span>
                  } @else {
                    <span class="run-status-pill skipped"><i class="fa-solid fa-circle-minus" aria-hidden="true"></i> Non eseguito</span>
                  }
                </div>

                @if (selectedGraphResult(); as step) {
                  <div class="flex flex-wrap items-center gap-4 mt-2 text-sm">
                    <span class="run-meta"><i class="fa-regular fa-clock"></i> {{ formatDuration(step.durationMs) }}</span>
                    @if (step.addedTags?.length) {
                      <span class="flex items-center gap-1">
                        <strong>+</strong>
                        @for (tag of step.addedTags; track tag) { <span class="chip add-tag">{{ tagName(tag) }}</span> }
                      </span>
                    }
                    @if (step.removedTags?.length) {
                      <span class="flex items-center gap-1">
                        <strong>-</strong>
                        @for (tag of step.removedTags; track tag) { <span class="chip remove-tag">{{ tagName(tag) }}</span> }
                      </span>
                    }
                  </div>
                  @if (step.message) {
                    <div class="run-error-text mt-2"><i class="fa-solid fa-circle-exclamation"></i> {{ step.message }}</div>
                  }
                }
              </div>
            }

            <div class="run-graph-timeline">
              <button
                type="button"
                class="fq-btn fq-btn-sm fq-btn-secondary"
                [disabled]="!timelineLength()"
                [attr.title]="timelinePlaying() ? 'Pausa' : 'Riproduci'"
                (click)="toggleTimelinePlay()">
                <i class="fa-solid" [ngClass]="timelinePlaying() ? 'fa-pause' : 'fa-play'"></i>
              </button>
              <button
                type="button"
                class="fq-btn fq-btn-sm fq-btn-secondary"
                [disabled]="!timelineLength()"
                title="Ripeti da capo"
                (click)="restartTimeline()">
                <i class="fa-solid fa-rotate-left"></i>
              </button>
              <input
                type="range"
                class="run-graph-seek"
                min="0"
                [max]="timelineLength()"
                step="1"
                [value]="effectiveTimelineIndex()"
                [disabled]="!timelineLength()"
                (input)="onTimelineSeek($any($event.target).value)" />
              <span class="run-graph-timeline-label">
                @if (timelineCurrentStep(); as step) {
                  <strong>{{ effectiveTimelineIndex() }}/{{ timelineLength() }}</strong>
                  <span class="run-status-pill" [ngClass]="statusKey(step.status)">{{ statusLabel(step.status) }}</span>
                  <span class="run-graph-step-label">{{ step.stepLabel }}</span>
                } @else {
                  <strong>0/{{ timelineLength() }}</strong>
                  <span class="run-graph-step-label">
                    @if (timelineLength()) { Non ancora avviato } @else { Nessun dato di esecuzione }
                  </span>
                }
              </span>
            </div>
          </div>
        </section>
      } @else {

      <section class="panel">
        <div class="fq-card-header fuseqCardHeader">Azioni configurate</div>
        <div class="panel-body">
          @for (action of run.actions; track $index) {
            <div class="run-action-card">
              <div class="run-action-head">
                <i class="fa-solid fa-gear run-action-icon"></i>
                <strong>{{ action.name }}</strong>
                <span class="chip cat">{{ action.type }}</span>
              </div>

              @if (paramsEntries(action).length) {
                <div class="run-action-params">
                  @for (p of paramsEntries(action); track p.key) {
                    <span class="chip neutral">{{ p.key }}: {{ p.value }}</span>
                  }
                </div>
              }

              <div class="run-action-outcomes">
                @for (outcome of action.outcomes; track outcome.key) {
                  <div class="run-outcome">
                    <span class="run-outcome-label" [ngClass]="outcomeSeverityOf(outcome)">
                      <i [class]="outcomeIconOf(outcome)"></i> {{ outcomeLabelOf(outcome) }}
                    </span>
                    <div class="run-outcome-chips">
                      @for (tagId of outcome.addTags; track tagId) { <span class="chip add-tag">+ {{ tagName(tagId) }}</span> }
                      @for (tagId of outcome.removeTags; track tagId) { <span class="chip remove-tag">- {{ tagName(tagId) }}</span> }
                        @if (!outcome.addTags.length && !outcome.removeTags.length) {
                        <span class="empty-inline">nessun tag</span>
                      }
                    </div>
                  </div>
                }
              </div>

              @if (action.post_actions?.length) {
                <div class="run-action-posts">
                  @for (post of action.post_actions; track $index) {
                    <span class="chip cat"><i class="fa-solid fa-paper-plane"></i> {{ postActionSummary(post) }}</span>
                  }
                </div>
              }
            </div>
          }
        </div>
      </section>

      <section class="panel">
        <div class="fq-card-header fuseqCardHeader">Esiti per frazionario</div>
        <div class="panel-body">
          @if (run.results?.length) {
            @for (result of run.results; track result.fraz) {
              <div class="run-result-row">
                <strong class="run-result-fraz">{{ result.fraz }}</strong>
                <div class="flex flex-col gap-1">
                  <div class="run-result-steps">
                    @for (step of result.steps; track step.stepId + '-' + $index) {
                      <span class="run-status-pill" [ngClass]="statusKey(step.status)">{{ step.stepLabel }}: {{ statusLabel(step.status) }}</span>
                    }
                  </div>
                  @if (resultFailureMessage(result); as failure) {
                    <span class="run-error-text"><i class="fa-solid fa-triangle-exclamation"></i> {{ failure }}</span>
                  }
                </div>
              </div>
            }
          } @else {
            <div class="runs-empty">
              <i class="fa-solid fa-list-check" aria-hidden="true"></i>
              @if (isRunActive(run.status)) {
                <span>Esecuzione in corso… aggiorna per vedere gli esiti.</span>
              } @else {
                <span>Nessun risultato disponibile.</span>
              }
            </div>
          }
        </div>
      </section>
      }
    </div>
  }
</p-dialog>
</div>

